<div class="tw-bg-white tw-p-4 tw-flex tw-flex-col tw-gap-2" (click)="handleBannerClick()">
  <span class="tw-relative tw-isolate tw-inline-flex tw-self-start apply-container before:tw-rounded-5 before:tw-absolute before:tw-inset-0 before:tw-z-[-1] before:tw-p-[2px]">
    <div class="complete-profile-hero-pill tw-flex tw-items-center tw-justify-center tw-gap-1 tw-pl-2 tw-pr-2 tw-py-1 tw-m-0.5 tw-rounded-full">
      <cs-icon [iconName]="aiAnalysisIcon" class="tw-w-4 tw-h-4"></cs-icon>
      <p class="tw-text-[9px] tw-text-white tw-uppercase tw-font-bold tw-font-body" i18n="@@aiAnalysis">ai analysis</p>
    </div>
  </span>
  <div class="tw-flex tw-flex-col">
    <h2 class="tw-font-lexend tw-font-bold tw-text-600 tw-text-black tw-m-0" i18n="@@completeYourProfile">Complete Your Profile</h2>
    @if (isFaceActive()) {
      <p class="tw-text-200 tw-text-gray-500 tw-opacity-80 tw-m-0" i18n="@@allFacePhotosHelpDetectConcerns">All 3 photos help us detect all concerns</p>
    } @else {
      <p class="tw-text-200 tw-text-gray-500 tw-opacity-80 tw-m-0" i18n="@@allHairPhotosHelpDetectConcerns">Both photos help us detect all concerns</p>
    }
  </div>

  <div class="tw-flex tw-gap-4 tw-border-b tw-border-solid tw-border-gray-200">
    @for (section of sections(); track section.regimenClass) {
      <button type="button"
              [id]="'cyp-tab-' + section.regimenClass"
              (click)="selectClass($event, section.regimenClass)"
              class="tw-bg-transparent tw-border-0 tw-px-0 tw--mb-px tw-border-b-2 tw-border-solid tw-font-lexend tw-text-300 tw-min-w-fit tw-m-0 tw-h-fit tw-rounded-none"
              [class]="section.regimenClass === activeClass() ? 'tw-text-teal-500 tw-font-bold tw-border-teal-500' : 'tw-text-gray-500 tw-font-normal tw-border-transparent'">
        @switch (section.regimenClass) {
          @case (regimenClassEnum.FACE) { <ng-container i18n="@@face">Face</ng-container> }
          @case (regimenClassEnum.HAIR) { <ng-container i18n="@@hair">Hair</ng-container> }
        }
      </button>
    }
  </div>


  <div class="tw-flex tw-justify-between" [class]="isFaceActive() ? 'tw-gap-5': 'tw-gap-3'" >
    @for (slot of slots(); track slot.type) {
      <div class="tw-flex tw-flex-1 tw-min-w-0 tw-flex-col tw-gap-1 tw-items-center" [id]="'cyp-slot-' + slot.type" (click)="handleSlotClick($event, slot)">
        <div class="tw-relative tw-w-full tw-h-34 tw-rounded-2 tw-overflow-hidden tw-bg-gray-200 tw-border-2 tw-border-solid tw-border-white tw-shadow-z1">
          @if (slot.checkup?.imagePath) {
            <img class="tw-w-full tw-h-full tw-object-cover" [src]="slot.checkup?.imagePath" alt="uploaded photo">
            <cs-icon [iconName]="checkIcon" class="tw-text-teal-600 tw-w-4 tw-h-4 tw-absolute tw-top-1 tw-right-1"></cs-icon>
          } @else {
            <img class="tw-absolute tw-inset-0 tw-m-auto tw-w-[52px] tw-h-[76px]" [src]="scanFrameImage" alt="">
            <img class="tw-absolute tw-inset-0 tw-m-auto tw-h-12" [class]="slot.type === checkupType.FRONT_FACE ? 'tw-w-8' : 'tw-w-11'" [src]="slot.placeholderImage" alt="photo placeholder">
          }
        </div>
        <p class="tw-text-100 tw-font-medium tw-text-gray-400 tw-tracking-tighter tw-uppercase tw-m-0 tw-text-center">
          @switch (slot.type) {
            @case (checkupType.FRONT_FACE) { <ng-container i18n="@@frontPhoto"> FRONT PHOTO </ng-container> }
            @case (checkupType.LEFT_SIDE_FACE) { <ng-container i18n="@@leftSidePhoto">Left side photo</ng-container> }
            @case (checkupType.RIGHT_SIDE_FACE) { <ng-container i18n="@@rightSidePhoto">Right side photo</ng-container> }
            @case (checkupType.HAIR_FRONT) { <ng-container i18n="@@hairFrontPhoto">Hair front photo</ng-container> }
            @case (checkupType.HAIR_TOP) { <ng-container i18n="@@hairTopPhoto">Hair top photo</ng-container> }
          }
        </p>
      </div>
    }
  </div>

  <div class="tw-flex tw-flex-col tw-items-center tw-gap-1 tw-w-full">
    <button csButton
            id="cyp-take-photo-cta"
            type="button"
            (click)="handleCtaClick($event)"
            class="shine loop tw-w-full tw-py-2 tw-gap-2 tw-text-400 tw-font-semibold tw-h-fit tw-max-w-none">
      <span i18n="@@takePhoto">Take Photo</span>
      <span class="cs-icon-camera tw-text-400 tw-mt-[2px]"></span>
    </button>
    <p class="tw-text-100 tw-text-gray-500 tw-opacity-80 tw-m-0 tw-lowercase" i18n="@@securePhotoPrivacyProtected">Secure Photo | Privacy Protected</p>
  </div>
</div>
